var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "2ax4agu66a",
    d: "M15.965 19c-.06-.004-.076-.004-.135-.014-.135-.023-.265-.074-.379-.15-.058-.037-.108-.081-.159-.128l-6-6c-.041-.045-.053-.055-.09-.103-.04-.055-.077-.114-.106-.175-.128-.27-.128-.59 0-.86.03-.06.065-.12.106-.174.037-.048.049-.059.09-.103l6-6c.045-.041.055-.053.103-.09.127-.096.277-.161.435-.188.112-.02.227-.02.34 0 .09.015.177.043.259.082.312.148.53.457.565.8.014.137 0 .275-.041.406-.035.108-.088.21-.157.301-.036.049-.048.059-.09.103L11.415 12l5.293 5.293.046.05c.039.047.05.058.083.11.062.094.108.2.135.31.022.09.031.18.028.272-.012.345-.208.668-.51.837-.099.056-.207.095-.32.114-.06.01-.075.01-.135.014h-.069z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-545 -232) translate(170 167) translate(16 48) translate(359 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "hkb1w95lwb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2ax4agu66a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    className: "fillable",
    mask: "url(#hkb1w95lwb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.1863782d47e586888efd0b7690dd8854.svg";
export { ForwardRef as ReactComponent };